import { useEffect, useState } from "react";
import {
  Input,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  InputGroupAddon,
  Button,
  Row,
  Col,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { isNullOrEmpty } from "../../../../config/ENV";
import { BsFillEyeFill } from "react-icons/bs";
import {
  getContactNotes,
  getLocationContactNotes,
} from "../../../../services/AccountService";
import { showLocalDateTime } from "../../../../utilities/timeutility";
import Linkify from "react-linkify";
import { Colxx } from "../../../../components/common/CustomBootstrap";

const JobReqLocation = (props) => {
  const {
    parentCallback,
    jobStatus,
    locationContacts,
    selectedContact,
    selectedContactId,
    locationContactsView,
    locationId,
  } = props;
  const [locationContact, setLocationContact] = useState(selectedContact);
  const [baseModalright, setBaseModalRight] = useState(false);
  const [locationView, setLocationView] = useState(locationContactsView);

  const [notesList, setNotesList] = useState([]);
  const [locationContactName, setLocationContactName] = useState("");
  let count = 0;
  useEffect(() => {


    if (locationContactName === "Select Location Account") {
      setLocationView(false);
    }

    if (!isNullOrEmpty(selectedContactId)) {
      setLocationContactName(selectedContactId);
    } else {
      setLocationContactName("");
    }
    if (
      !isNullOrEmpty(selectedContact) &&
      selectedContact != null &&
      selectedContact != undefined
    ) {
      setLocationContact(selectedContact);
    } else {
      setLocationContact("");
    }
    setLocationView(locationContactsView);
  }, [selectedContactId]);

  function handleAccountContactChange(e) {
    setLocationContactName(e.target.value);
    parentCallback(e.target.value);
    for (var i = 0; i < locationContacts.length; i++) {
      if (locationContacts[i].id === e.target.value) {
        setLocationContact(locationContacts[i]);
        // setLocationView(true);

        return;
      }
    }
  }

  useEffect(() => {
    if (!isNullOrEmpty(locationContactName) && !isNullOrEmpty(locationId)) {
      getNotes();
    }
  }, [locationContactName]);

  useEffect(() => {
    if (!isNullOrEmpty(locationContactName)) {
      getAccountNotes();
    }
  }, [locationContactName]);

  const getNotes = () => {
    getLocationContactNotes(locationId, locationContactName).then(
      (response) => {
        if (response.status === 200) {
          setNotesList(response.data.contactNotes);
        }
      }
    );
  };

  const getAccountNotes = () => {
    getContactNotes(locationContactName).then((response) => {
      if (response.status === 200) {
        setNotesList(response.data.contactNotes);
        // setContactNoteId(response.data.contactNotes.id);
      }
    });
  };

  const showName = (name) => {
    if (!isNullOrEmpty(name)) {
      if (name.includes("null")) {
        let Arr = [];
        Arr = name.split(" ");
        delete Arr[1];
        return Arr[0];
      }
    }

    return name;
  };

  const showNotesList = (notes) => {
    return (
      <>
        {notes.length > 0 &&
          notes.map((note, index) => {
            return (
              <div key={note.id}>
                <div className="">
                  <span>
                    <div>
                      <div className="row ">
                        <Col className="col-9 p-0">
                          <Col>
                            <span className=" mr-2 font-semibold ">
                              {showName(note.commentedByName)}
                            </span>
                            <div>{showLocalDateTime(note.createdOn)}</div>
                            <div>
                              <Linkify>{note.notes}</Linkify>
                            </div>
                            <Row>
                              <Col> </Col>
                            </Row>
                          </Col>
                        </Col>

                        {/* <Col className="text-right">
                          {showDeleteButton(note)}
                        </Col> */}
                      </div>
                    </div>
                  </span>
                </div>
                {notes.length > 1 && index != notes.length - 1 && (
                  <>
                    <hr />
                  </>
                )}
              </div>
            );
          })}
      </>
    );
  };

  return (
    <>
      <Input
        type="select"
        value={locationContactName}
        onChange={(e) => handleAccountContactChange(e)}
      >
        <option value="" className="t-rounded-lg">
          Select Account Contact
        </option>
        {locationContacts.map((locationContact) => {
          return (
            
            <option key={locationContact.id} value={locationContact.id} className="t-bold-weight">
               {locationContact.firstName} {!isNullOrEmpty(locationContact.lastName) && locationContact.lastName}
             
            </option>
          );
        })}
      </Input>

      {locationView === true ? (
        <>
        {!isNullOrEmpty(locationContactName) &&
        
        locationContactName !== "Select Location Contact"  && <InputGroupAddon addonType="append">
            <Button
              // className="t-input-group-right-radius"
              color="dark"
              outline
              onClick={() => setBaseModalRight(true)}
            >
              <BsFillEyeFill className="danger" />
            </Button>
          </InputGroupAddon>}
          {" "}
         
        </>
      ) : (
        <></>
      )}

      <Modal
        scrollable={true}
        isOpen={baseModalright}
        toggle={() => setBaseModalRight(!baseModalright)}
        wrapClassName="modal-right"
        className="skill-model-width"
      >
        <>
          {!isNullOrEmpty(locationContact) ? (
            <>
              <ModalHeader className="benefitmodal_header">
                {" "}
                <h2>
                  {" "}
                  <strong> {locationContact.firstName}</strong>
                </h2>
              </ModalHeader>
              <ModalBody>
                <Row className="">
                  <Colxx sm={2}>
                    <Label> Email </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b>{locationContact.email}</b>
                  </Colxx>
                </Row>
                <Row className="">
                  <Colxx sm={2}>
                    <Label> Mobil Number </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b> {locationContact.mobileNumber}</b>
                  </Colxx>
                </Row>
                <Row className="">
                  <Colxx sm={2}>
                    <Label> Office Number </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b>{locationContact.officeNumber}</b>
                  </Colxx>
                </Row>
                <Row className="">
                  <Colxx sm={2}>
                    <Label> Linkedin Url </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b>{locationContact.linkedInUrl}</b>
                  </Colxx>
                </Row>
                <Row className="">
                  <Colxx sm={2}>
                    <Label>Facebook Url </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b>{locationContact.facebookUrl}</b>
                  </Colxx>
                </Row>
                <Row className="">
                  <Colxx sm={2}>
                    <Label> Twitter Url </Label>
                  </Colxx>
                  :
                  <Colxx sm={8}>
                    <b>{locationContact.twitterUrl}</b>
                  </Colxx>
                </Row>

                {!isNullOrEmpty(notesList) ? (
                  <>
                    <hr />
                    <Row className="">
                      <Colxx>
                        <strong>Notes:</strong>
                        <CardBody className="px-0">
                          {!isNullOrEmpty(notesList) && (
                            <> {showNotesList(notesList)}</>
                          )}
                        </CardBody>
                      </Colxx>
                    </Row>
                  </>
                ) : (
                  <></>
                )}
              </ModalBody>
            </>
          ) : (
            <></>
          )}

          {/* {locationContact.email} */}
        </>

        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => setBaseModalRight(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default JobReqLocation;